<template>
  <div ref="Xterminate" class="text-justify transparent">
    <h1 class="text-center">{{ $t("portfolio.xterminate.pageLabel") }}</h1>
    <hr class="primary" />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Xterminate"
};
</script>
